import React from 'react';
import { Link } from 'react-router-dom';
import GradientText from './reactbits/GradientText/GradientText';
import Reveal from './ui/Reveal';
import SpotlightCard from './reactbits/SpotlightCard/SpotlightCard';

const faqCategories = [
  {
    id: 'progress',
    title: 'Progress',
    questions: [
      {
        question: 'How often will I receive updates on my project?',
        answer: 'We provide weekly progress reports and milestone updates via email and your client dashboard.',
      },
      {
        question: 'Can I suggest changes during the development process?',
        answer: 'Absolutely! You can suggest changes at any time. Just communicate with your dedicated project manager.',
      },
      {
        question: 'Will I be involved in the design review stages?',
        answer: 'Yes, we involve clients in key design reviews to ensure alignment before development begins.',
      },
    ],
  },
  {
    id: 'payment',
    title: 'Payment',
    questions: [
      {
        question: 'What are your pricing models?',
        answer: 'We offer fixed-price, milestone-based, and monthly retainer pricing depending on your project type.',
      },
      {
        question: 'Do I need to pay the full amount upfront?',
        answer: 'No, we usually follow a milestone-based payment structure—e.g., 30% upfront, 40% during progress, and 30% on delivery.',
      },
      {
        question: 'Are there any hidden or additional charges?',
        answer: 'No hidden fees. All potential costs are discussed upfront in your proposal or contract.',
      },
      {
        question: 'Can I upgrade or downgrade my service package?',
        answer: 'Yes, we offer flexible packages that can be adjusted based on your evolving needs.',
      },
    ],
  },
  {
    id: 'support',
    title: 'Support',
    questions: [
      {
        question: 'What kind of post-launch support do you offer?',
        answer: 'We offer 30-day complimentary support post-launch, and extended support is available under our maintenance plans.',
      },
      {
        question: 'How can I report a bug or issue?',
        answer: 'You can report issues through your dashboard, email, or by contacting your account manager directly.',
      },
      {
        question: 'Do you provide hosting or domain services?',
        answer: 'Yes, we can help set up hosting and domain registration through our trusted partners.',
      },
      {
        question: 'What are your customer support hours?',
        answer: 'Our support team is available 9 AM to 9 PM (GMT+5), Monday to Saturday. Emergency support is available for critical issues.',
      },
    ],
  },
];


const FAQsMain = () => {
  return (
    <div className="faq-page sec-mar">
      <div className="container">
        <div className="row gy-5 justify-content-lg-between justify-content-center">
          
          {/* Left Column - Tabs + Form */}
          <Reveal className="col-lg-4" delay={0.08}>
            <div className="faq-items">
              <ul className="nav nav-tabs" id="faqTabs" role="tablist">
                {faqCategories.map((category, index) => (
                  <li className="nav-item" role="presentation" key={category.id}>
                    <button
                      className={`nav-link ${index === 0 ? 'active' : ''}`}
                      id={`${category.id}-tab`}
                      data-bs-toggle="tab"
                      data-bs-target={`#${category.id}`}
                      type="button"
                      role="tab"
                      aria-controls={category.id}
                      aria-selected={index === 0 ? 'true' : 'false'}
                    >
                      {category.title}
                    </button>
                  </li>
                ))}
              </ul>
            </div>

            {/* Contact Form */}
            <SpotlightCard className="contact-form-wrap nalexus-spotlight" spotlightColor="rgba(223, 169, 37, 0.25)">
              <div className="form-tltle">
                <h5>
                  <GradientText as="span" className="nalexus-heading-gradient" animationSpeed={12}>
                    HAVE QUESTION?
                  </GradientText>
                </h5>
              </div>
              <div className="contact-form">
                <p>Share your question through the contact page so you can review the request before sending it.</p>
                <Link className="primary-btn3 nalexus-cta" to="/contact">Ask Nalexus</Link>
              </div>
            </SpotlightCard>
          </Reveal>

          {/* Right Column - Accordion Tabs */}
          <Reveal className="col-lg-8" delay={0.12}>
            <div className="tab-content" id="faqTabContent">
              {faqCategories.map((category, tabIndex) => (
                <div
                  key={category.id}
                  className={`tab-pane fade ${tabIndex === 0 ? 'show active' : ''}`}
                  id={category.id}
                  role="tabpanel"
                  aria-labelledby={`${category.id}-tab`}
                >
                  <div className="accordion" id={`accordion-${category.id}`}>
                    {category.questions.map((q, qIndex) => {
                      const headingId = `heading-${category.id}-${qIndex}`;
                      const collapseId = `collapse-${category.id}-${qIndex}`;
                      return (
                        <div className="accordion-item" key={collapseId}>
                          <h5 className="accordion-header" id={headingId}>
                            <button
                              className={`accordion-button ${qIndex !== 0 ? 'collapsed' : ''}`}
                              type="button"
                              data-bs-toggle="collapse"
                              data-bs-target={`#${collapseId}`}
                              aria-expanded={qIndex === 0 ? 'true' : 'false'}
                              aria-controls={collapseId}
                            >
                              {q.question}
                            </button>
                          </h5>
                          <div
                            id={collapseId}
                            className={`accordion-collapse collapse ${qIndex === 0 ? 'show' : ''}`}
                            aria-labelledby={headingId}
                            data-bs-parent={`#accordion-${category.id}`}
                          >
                            <div className="accordion-body">{q.answer}</div>
                          </div>
                        </div>
                      );
                    })}
                  </div>
                </div>
              ))}
            </div>
          </Reveal>

        </div>
      </div>
    </div>
  );
};

export default FAQsMain;



